<template>
    <div>
        <!-- Two columns, in the same order as before (left to right, then down). -->
        <el-form ref="form" class="location-form" :rules="rules" :model="locationInfo" label-position="top">
            <div class="form-grid">
                <el-form-item label="Ref">
                    <el-input v-model="tempReference"></el-input>
                </el-form-item>

                <el-form-item label="Rating">
                    <el-slider
                            v-model="locationInfo.rating"
                            :step="1"
                            :max="5"
                            @change="updateRating"
                            show-stops>
                    </el-slider>
                </el-form-item>

                <el-form-item label="Location Title" prop="locationTitle">
                    <el-input v-model="locationInfo.locationTitle"></el-input>
                </el-form-item>

                <el-form-item label="Location Name">
                    <el-input v-model="locationInfo.locationName"></el-input>
                </el-form-item>

                <el-form-item label="Address One">
                    <el-input v-model="locationInfo.addressOne"></el-input>
                </el-form-item>

                <el-form-item label="Address Two">
                    <el-input v-model="locationInfo.addressTwo"></el-input>
                </el-form-item>

                <el-form-item label="Address Three">
                    <el-input v-model="locationInfo.addressThree"></el-input>
                </el-form-item>

                <el-form-item label="Postcode">
                    <el-input v-model="locationInfo.postcode"></el-input>
                </el-form-item>

                <el-form-item class="form-grid__full" label="Description">
                    <el-input type="textarea" :autosize="{minRows: 6, maxRows: 16}" v-model="locationInfo.description"></el-input>
                </el-form-item>

                <el-form-item label="County">
                    <el-select v-model="locationInfo.county" placeholder="please select area">
                        <el-option  v-for="area in areas" :label="area" :value="area"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Property Type">
                    <el-radio-group v-model="locationInfo.propertyType" size="medium">
                        <el-radio-button label="House"></el-radio-button>
                        <el-radio-button label="Apartment"></el-radio-button>
                        <el-radio-button label="Other"></el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item v-if="locationInfo.propertyType == 'Apartment'" label="Building Manager">
                    <el-radio-group v-model="locationInfo.buildingManager" size="medium">
                        <el-radio-button :label="true">Yes</el-radio-button>
                        <el-radio-button :label="false">No</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item v-if="locationInfo.propertyType == 'Apartment'"
                              label="Apartment Restrictions">
                    <el-radio-group v-model="locationInfo.apartmentRestrictions" size="medium">
                        <el-radio-button :label="true">Yes</el-radio-button>
                        <el-radio-button :label="false">No</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item v-if="locationInfo.propertyType == 'Other'" label="Other Property Type">
                    <el-input v-model="locationInfo.otherPropertyType"></el-input>
                </el-form-item>

                <el-form-item label="Number of Bedrooms">
                    <el-select v-model="locationInfo.bedrooms" placeholder="Select">

                      <el-option
                        :key="0"
                        :label="0"
                        :value="0">
                      </el-option>

                      <el-option
                        v-for="i in 9"
                        :key="i"
                        :label="i"
                        :value="i">
                      </el-option>

                      <el-option
                        key="10+"
                        label="10+"
                        value="10+">
                      </el-option>

                    </el-select>
                </el-form-item>

                <el-form-item label="Number of Bathrooms">
                    <el-select v-model="locationInfo.bathrooms" placeholder="Select">

                      <el-option
                        :key="0"
                        :label="0"
                        :value="0">
                      </el-option>

                      <el-option
                        v-for="i in 9"
                        :key="i"
                        :label="i"
                        :value="i">
                      </el-option>

                      <el-option
                        key="10+"
                        label="10+"
                        value="10+">
                      </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Decorating">
                    <el-radio-group v-model="locationInfo.decorating" size="medium">
                        <el-radio-button :label="true">Yes</el-radio-button>
                        <el-radio-button :label="false">No</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="Parking">
                    <el-radio-group v-model="locationInfo.parking" size="medium">
                        <el-radio-button label="Off-Road"></el-radio-button>
                        <el-radio-button label="Restricted"></el-radio-button>
                        <el-radio-button label="Unrestricted"></el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item v-if="locationInfo.parking == 'Off-Road'" label="Off-road cars"
                              >
                    <el-select v-model="locationInfo.numOfOffRoadCars" placeholder="Select">
                        <el-option
                                key="none"
                                label="None"
                                value="none">
                        </el-option>
                        <el-option
                                v-for="index in 9"
                                :key="index"
                                :label="index"
                                :value="index">
                        </el-option>
                        <el-option
                                key="10plus"
                                label="More than 10"
                                value="10plus">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Nearest Train/Tube Station">
                    <el-input v-model="locationInfo.nearestStation"></el-input>
                </el-form-item>
            </div>

            <div class="form-actions">
                <el-button type="primary" @click="onSubmit">Save</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import auth from '../mixins/auth';
    import * as queryString from 'query-string';
    export default {
        props: ['location'],
        mixins: [auth],
        data() {
            return {
                locationInfo: {
                },
                areas: [],

                // This is used so that the reference can be changed without affecting the page (as the reference is obtained in the URL)
                tempReference: '',

              rules: {
                locationTitle: [
                  { max: 31, message: 'Length should be less than 31 characters', trigger: 'blur'}
                ],
              }
            }
        },
        methods: {

            saveLocation() {

                return this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.location._id}`,
                    this.locationInfo, {headers: this.headers});

            },

            updateRating() {
                this.saveLocation()
                    .then(response => {
                        this.$notify({
                            message: 'Rating Updated',
                            type: 'success'
                        });
                    }).catch(err => {
                    this.$notify({
                        title: 'Error',
                        message: 'Error Updating Rating',
                    });
                });
                // console.log('updating rating');
            },

            onSubmit() {
              this.$refs['form'].validate((valid) => {
                if (valid) {

                  // Re-assign the location reference to = temp reference.
                  this.locationInfo.locationReference = this.tempReference;


                  this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.location._id}`,
                    this.locationInfo,
                    {
                      headers: {
                        Authorization: localStorage.getItem('Authorization')
                      }
                    })
                    .then(response => {

                      console.log(response.data);
                      // In case the reference has changed.
                      // We include the query in case they need to go back to search
                      this.$router.push('/locations/' + this.tempReference + '?' + queryString.stringify(this.$route.query));

                      this.$notify({
                        title: 'Success',
                        message: 'Location updated.',
                        type: 'success'
                      });


                    })
                    .catch(error => {
                      console.log(error);

                    });


                } else {
                  console.log('error submit!!');
                  this.$notify.error({
                    title: 'Error',
                    message: 'Error in one or more inputs'
                  });
                  return false;
                }
              });


            },


        },


        beforeMount() {

            //HERE WE NEED TO CHECK IF IT COMES FROM A PROP OR THE URL.

            if (!this.location) {

                console.log('LOCATION DOESNT EXIST');

                // We have to do find by ref because we dont have access to location ID at this point
                this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/locations/findbyref/${this.$route.params.locationRef}`,
                    {
                        headers: {
                            Authorization: localStorage.getItem('Authorization')
                        }
                    })
                    .then(response => {

                        this.locationInfo = response.data;
                        this.tempReference = response.data.locationReference;

                    })
                    .catch(error => {
                        console.log(error);
                    });


            } else {

                this.locationInfo = this.location;
                this.tempReference = this.location.locationReference;

            }

            //  Getting area list
            this.axios.get(process.env.VUE_APP_ROOT_API + '/api/genericData/areas')
                .then(response => {

                    this.areas = response.data.areas;
                }).catch(err => {
                console.log(err);
            });


        },
    }
</script>

<style scoped>
    .form-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: 40px;
        max-width: 1040px;
    }

    .form-grid__full {
        grid-column: 1 / -1;
    }

    .form-grid >>> .el-form-item__content > .el-input,
    .form-grid >>> .el-form-item__content > .el-select,
    .form-grid >>> .el-form-item__content > .el-textarea {
        max-width: none;
    }

    .location-form >>> .el-slider {
        padding: 0 8px;
    }

    @media (max-width: 900px) {
        .form-grid {
            grid-template-columns: minmax(0, 1fr);
        }
    }
</style>



// WEBPACK FOOTER //
// src/locations/LocationInformation.vue